module.exports = __webpack_public_path__ + "static/media/food_7.11053389.jpeg";